export default __webpack_public_path__ + "static/media/homepage_7.b7a0c660.png";